import React from "react";

type RsSearchProps = React.SVGProps<SVGSVGElement>;

export default function RsSearch(props: RsSearchProps) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6999_6767)">
        <path
          d="M4.66797 5.33333V4H10.0013V5.33333H4.66797ZM2.66797 14.6667C2.49116 14.6667 2.32159 14.5964 2.19656 14.4714C2.07154 14.3464 2.0013 14.1768 2.0013 14V2C2.0013 1.82319 2.07154 1.65362 2.19656 1.5286C2.32159 1.40357 2.49116 1.33333 2.66797 1.33333H12.668V7.66667C13.163 7.87501 13.6151 8.17339 14.0013 8.54667V0H2.66797C2.13754 0 1.62883 0.210714 1.25376 0.585786C0.878683 0.960859 0.667969 1.46957 0.667969 2V14C0.667969 14.5304 0.878683 15.0391 1.25376 15.4142C1.62883 15.7893 2.13754 16 2.66797 16H11.0013C10.4183 15.9999 9.84128 15.8818 9.30517 15.6526C8.76905 15.4234 8.28492 15.0881 7.88197 14.6667H2.66797ZM14.3633 15.9713L12.592 14.2C12.1168 14.5033 11.5651 14.6652 11.0013 14.6667C10.408 14.6667 9.82794 14.4907 9.33459 14.1611C8.84124 13.8314 8.45673 13.3629 8.22966 12.8147C8.0026 12.2665 7.94319 11.6633 8.05895 11.0814C8.1747 10.4995 8.46042 9.9649 8.87998 9.54535C9.29954 9.12579 9.83409 8.84007 10.416 8.72431C10.998 8.60856 11.6012 8.66797 12.1494 8.89503C12.6975 9.12209 13.1661 9.50661 13.4957 9.99996C13.8254 10.4933 14.0013 11.0733 14.0013 11.6667C13.9998 12.2304 13.8379 12.7821 13.5346 13.2573L15.306 15.0287L14.3633 15.9713ZM11.0013 13.3333C11.3309 13.3333 11.6532 13.2356 11.9273 13.0524C12.2013 12.8693 12.415 12.609 12.5411 12.3045C12.6672 11.9999 12.7003 11.6648 12.6359 11.3415C12.5716 11.0182 12.4129 10.7212 12.1798 10.4882C11.9467 10.2551 11.6498 10.0963 11.3265 10.032C11.0032 9.96772 10.668 10.0007 10.3635 10.1269C10.059 10.253 9.79866 10.4666 9.61552 10.7407C9.43238 11.0148 9.33464 11.337 9.33464 11.6667C9.33464 12.1087 9.51023 12.5326 9.82279 12.8452C10.1354 13.1577 10.5593 13.3333 11.0013 13.3333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6999_6767">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(-0.666016)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
